import React, { Fragment, useState } from "react";
import { useLocation } from "react-router-dom";
import ActivityData from "../../activities-json";
import NewsDetails from "./newsDetails";
import "../../activities.scss";

type CareerListProps = {
  newsList: [];
  months: string[];
};

const SingleNews = (props: CareerListProps) => {
  let location: any = useLocation();
  let newsId = location.pathname.split("/")[4];

  const Data: any =
    props.newsList.length > 0 &&
    props.newsList.find((filterData: any) => {
      return filterData.id === newsId;
    });
  return (
    <div>
      <div className="container" id="introduction-details">
        <div className="activities" id="blogs">
          <NewsDetails news={Data} months={props.months} />
        </div>
      </div>
    </div>
  );
};

export default SingleNews;
